import { create } from "zustand";

interface FilterState {
  filters: Record<string, any>;
  setFilters: (filters: FilterState["filters"]) => void;
  resetFilters: () => void;
}

const defaultFilters: FilterState["filters"] = {
  query: { value: "", matchMode: "contains" },
  name: { value: "", matchMode: "contains" },
  clientId: { value: "", matchMode: "equals" },
  type: { value: "", matchMode: "equals" },
  poNumber: { value: "", matchMode: "equals" },
  endAt: { value: "", matchMode: "equals" },
  plafoundLeft: { value: "", matchMode: "equals" },
  status: { value: "", matchMode: "equals" },
};

export const useFilterPurchaseOrderStore = create<FilterState>((set) => ({
  filters: defaultFilters,
  setFilters: (filters) => set({ filters }),
  resetFilters: () => set({ filters: defaultFilters }),
}));
